export interface OrderItemDeletionFailure {
  messageKey?: string;
  messageArgs?: { [key: string]: any };
  defaultMessage?: string;
  count: number;
  parcelIds: number[];
}

export interface OrderItemDeletionSummary {
  failures: OrderItemDeletionFailure[];
  requestedCount: number;
  deletedCount: number;
  failureCount: number;
  error?: string;
  errorKey?: string;
  errorArgs?: { [key: string]: any };
}

function normalizeFailure(raw: any): OrderItemDeletionFailure {
  return {
    messageKey: raw && raw.messageKey ? raw.messageKey : null,
    messageArgs: raw && raw.messageArgs ? raw.messageArgs : {},
    defaultMessage: raw && raw.defaultMessage ? raw.defaultMessage : null,
    count: raw && typeof raw.count === 'number' ? raw.count : 0,
    parcelIds: raw && raw.parcelIds ? raw.parcelIds : [],
  };
}

export function normalizeDeletionSummary(raw: any): OrderItemDeletionSummary {
  const summary: OrderItemDeletionSummary = {
    failures: [],
    requestedCount: raw && typeof raw.requestedCount === 'number' ? raw.requestedCount : 0,
    deletedCount: raw && typeof raw.deletedCount === 'number' ? raw.deletedCount : 0,
    failureCount: raw && typeof raw.failureCount === 'number' ? raw.failureCount : 0,
    errorArgs: raw && raw.errorArgs ? raw.errorArgs : {},
  };

  if (raw && raw.error) {
    summary.error = raw.error;
  }

  if (raw && raw.errorKey) {
    summary.errorKey = raw.errorKey;
  }

  if (raw && raw.failures && raw.failures.length) {
    summary.failures = raw.failures.map((failure: any) => normalizeFailure(failure));
  }

  return summary;
}
